import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminCustomer } from "../../../domain/administrator/model";

type CustomerUpdateState = {
  loading: boolean;
  data: AdminCustomer;
  error: unknown;
};

const initialState: CustomerUpdateState = {
  loading: false,
  data: {
    id: "",
    email: "",
    name: "",
    phone: "",
    jobRole: null,
    acceptNotifications: false,
    role: "Customer",
    topics: [],
    challenges: [],
    twoFactorAuthentication: false,
    image: null,
    area: null,
    birthDate: null,
    language: "pt",
    createdAt: "",
    updatedAt: "",
    company: {
      id: "",
      name: "",
      paid: false,
    },
  },
  error: null,
};

const dataSlice = createSlice({
  name: "Customer/update",
  initialState: initialState,
  reducers: {
    eraseUpdateCustomerStore: () => {
      return { ...initialState };
    },
    setUpdateCustomerLoading: (state) => {
      state.loading = true;
    },
    setUpdateCustomerResult: (state, action: PayloadAction<AdminCustomer>) => {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setUpdateCustomerFailure: (state, action: PayloadAction<unknown>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  eraseUpdateCustomerStore,
  setUpdateCustomerFailure,
  setUpdateCustomerLoading,
  setUpdateCustomerResult,
} = dataSlice.actions;

export default dataSlice.reducer;
